import React, { useEffect, useState } from 'react';
import ProgressSteps from './progressSteps';
import nextIcon from "../../assets/nextIcon.png";
import statusIcon from "../../assets/status.png";
import { useEmployee } from '../../context/EmployeeContext';
import { NavLink } from 'react-router-dom';

const StepThree = ({setStepFromUrl}) => {
  const { employeeData } = useEmployee();
  const [withholdingForms, setWithholdingForms] = useState([]);

  useEffect(() => {
    if (employeeData?.onboard?.withholdings) {
      setWithholdingForms(employeeData.onboard.withholdings);
    }
  }, [employeeData]);

  return (
    <div>
      <ProgressSteps currentStep={3} />

      <div>
        <h5 className="mb-2 sub-title">Withholding Forms</h5>
        <p className="gray-text-for-content mb-4">Please complete the following payroll forms.</p>

        {withholdingForms.length > 0 ? (
          <div className="mb-4 bg-white rounded row">
            {withholdingForms.map((form, idx) => (
              <div key={idx} className='col-4 d-flex justify-content-between align-items-center'
                style={{
                  border: "1px solid #DFF2DD",
                  background: "#F6FFF5",
                  padding: "10px",
                  borderRadius: "10px",
                  margin: "0px 10px 0px 13px"
                }}>
                <div className='d-flex align-items-center'>
                  <img src={statusIcon} alt='' style={{ marginRight: "4px" }} />
                  <p className='gray-text-for-content m-0'>{form.name || 'Form'}</p>
                </div>
                <img src={nextIcon} alt='' />
              </div>
            ))}
          </div>
        ) : (
          <p className="gray-text-for-content">No withholding forms found.</p>
        )}
      </div>
        <div className="text-center mt-4">
            <NavLink
                type="button"
                to={'/manage-employee'}
                className="cancel-button px-4 mx-2 text-decoration-none"
            >
                Cancel
            </NavLink>
            <button type="button" onClick={() => setStepFromUrl(4)} className="dark-orange-button px-4">
                Continue
            </button>
        </div>
    </div>
  );
};

export default StepThree;
